import React, { Component } from 'react'

import { connect } from 'react-redux'
import { clearUploads, cancelUploads } from '../../../utils/upload'
import { translation } from '../../../utils/helpers'

// import styles
import './uploadoverlay.scss'

class UploadOverlay extends Component {
  constructor (props) {
    super(props)
    this.state = {
      inProgress: false,
      progress: 0
    }

    this.newProps = this.newProps.bind(this)
  }

  componentDidMount () {
    clearUploads()
    this.newProps(this.props)
  }

  componentWillReceiveProps (next) {
    this.newProps(next)
  }

  newProps (props) {
    this.setState({
      inProgress: props.inProgress,
      progress: props.progress
    }, this.forceUpdate)
  }

  render () {
    const { inProgress, progress } = this.state
    if (!inProgress || progress >= 100) return null
    return (
      <div className='upload_window'>
        <div className='count'>
          <span className='animated-background'>
            <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
            <span className='sr-only'>{translation('13382')}...</span>
          </span>
        </div>
        <div className='right'>
          <div className='top'>
            <div className='info'>{translation('14750')}</div>
            <div className='abort'>
              <div>{translation('14751')}</div>
              <span onClick={() => { cancelUploads() }}>X</span>
            </div>
          </div>
          <div className='progressframe'>
            <div>
              <div className='fill' style={{width: progress + '%'}}>&nbsp;</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    progress: state.uploads.progress,
    inProgress: state.uploads.inProgress
  }
}

export default connect(mapStateToProps)(UploadOverlay)



// WEBPACK FOOTER //
// ./src/app/shared/components/UploadOverlay/index.js